import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import OnboardingHeader from './OnboardingHeader';

// Full-bleed reveal/transition screens that hide the nav links (logo only, no Book a Demo).
// LandingScreen is intentionally absent — it uses the default showNav=true behaviour.
const FULL_BLEED_ROUTES = new Set([
  '/onboarding/lets-go',
  '/onboarding/guidebooks-reveal',
  '/onboarding/task-intro',
  '/onboarding/sms-reveal',
  '/onboarding/complete',
]);

const isFullBleed = (pathname) => {
  const normalized = pathname.replace(/\/$/, '');
  return FULL_BLEED_ROUTES.has(normalized);
};

// Routes that hide the header entirely — reveal-screen animations need a clean viewport.
// MessagingIntroStep is fullbleed but keeps the header visible.
const HIDE_HEADER_ROUTES = new Set([
  '/onboarding/lets-go',
  '/onboarding/guidebooks-reveal',
  '/onboarding/task-intro',
  '/onboarding/sms-reveal',
  '/onboarding/complete',
]);

const hideHeader = (pathname) => {
  const normalized = pathname.replace(/\/$/, '');
  return HIDE_HEADER_ROUTES.has(normalized);
};

const isLanding = (pathname) => pathname.replace(/\/$/, '') === '/onboarding';

const OnboardingShell = () => {
  const { pathname } = useLocation();
  const showNav = !isFullBleed(pathname);
  const headerHidden = hideHeader(pathname);
  const landingMode = isLanding(pathname);

  return (
    <div className={`hg-onboarding-shell${headerHidden ? ' hg-onboarding-shell--no-header' : ''}`}>
      {!headerHidden && <OnboardingHeader showNav={showNav} showHumanPill={landingMode} />}
      <div className="hg-onboarding-shell__outlet">
        <Outlet />
      </div>
    </div>
  );
};

export default OnboardingShell;
